/**
 * CRM sub-navigation (PRIVATE fork). Fork-owned — the upstream `nav-registry`
 * `NavModule` type is settings-scoped (`parent: 'settings'`), so the CRM page
 * defines its own lightweight sub-module list and renders its own tab bar (the
 * top-level CRM tab itself is contributed via page-registry's EXTRA_PAGES).
 */

import { BarChart3, Building2, Users, Package, DollarSign, Calendar, Star } from '../../lib/icons';
import type { LucideIcon } from '../../lib/icons';

export interface CrmModule {
  /** Route segment + cache key, e.g. 'companies' (home = ''). */
  key: string;
  label: string;
  icon: LucideIcon;
  /** Hash route, e.g. '#/crm/companies'. */
  path: string;
}

export const crmModules: CrmModule[] = [
  { key: 'home', label: 'Overview', icon: BarChart3, path: '#/crm' },
  { key: 'companies', label: 'Customers', icon: Building2, path: '#/crm/companies' },
  { key: 'contacts', label: 'Contacts', icon: Users, path: '#/crm/contacts' },
  { key: 'products', label: 'Products', icon: Package, path: '#/crm/products' },
  { key: 'deals', label: 'Deals', icon: DollarSign, path: '#/crm/deals' },
  { key: 'followups', label: 'Follow-ups', icon: Calendar, path: '#/crm/followups' },
  { key: 'influencers', label: 'Influencers', icon: Star, path: '#/crm/influencers' },
];
